import HeaderWrapperDesktop from "../header-wrapper-desktop"
import AptHeaderContent from "../apt-header-content"
import TabButton from "@/components/buttons/tab-button"
import { langStore } from "@/stores/lang-store"
import { overviewStore } from "@/routes/apt/[apt_code]/overivew/overview-store"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { headerBundle } from "./overview-header-const"
import Wrapper from "@/components/wrapper"

const OverviewHeaderDesktop = () => {
  const { lang } = langStore()
  const { unit_count } = aptSearchStore((s) => s.pickApt)

  const { selectedTab, tabClick } = overviewStore()

  return (
    <HeaderWrapperDesktop>
      <AptHeaderContent label={headerBundle.caption[lang]}>
        <div className="flex items-center gap-4">
          <article className="flex flex-col">
            <span className="text-[11px] text-gray-400 font-medium">
              {headerBundle.label[lang]}
            </span>

            <div className="flex items-end gap-1">
              <span className="text-2xl font-bold text-gray-900 leading-none">
                {unit_count?.toLocaleString()}
              </span>

              <span className="text-sm text-gray-500 mb-px">{headerBundle.unit[lang]}</span>
            </div>
          </article>

          <div className="w-px h-4 bg-gray-200" />

          <Wrapper.tab>
            {headerBundle.tabs.map((tab) => (
              <TabButton
                key={tab.id}
                onClick={() => tabClick(tab)}
                isActive={selectedTab.id === tab.id}
              >
                {tab.label[lang]}
              </TabButton>
            ))}
          </Wrapper.tab>
        </div>
      </AptHeaderContent>
    </HeaderWrapperDesktop>
  )
}

export default OverviewHeaderDesktop
